import { postRequest } from 'utils/http'

export function loginAPI(payload) {
  return postRequest(`users/login`, payload)
}
